
// Vue
import {Options, Vue} from "vue-class-component";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AdministratorNavigationVue from "@/components/administrator/navigation.vue";
import AdministratorTrainingsNavigationVue from "@/components/administrator/trainings/navigation.vue";
import AppAdministratorTrainingsCategoriesListIndexVue from "@/views/app/administrator/trainings/categories/list/index.vue";

@Options({
  components: {
    ElRow,
    ElCol,
    AdministratorNavigationVue,
    AdministratorTrainingsNavigationVue,
    AppAdministratorTrainingsCategoriesListIndexVue,
  },
})
export default class AppAdministratorTrainingsCategoriesIndexVue extends Vue {}
